import axios from "axios";
import swal from "sweetalert";
import { loginConfirmedAction, Logout } from "../store/actions/AuthActions";

export function signUp(name, email, password) {
  //axios call
  const postData = {
    name,
    email,
    password,
    //returnSecureToken: true,
  };
  return axios.post(
    `${process.env.REACT_APP_APIS_BASE_URL}/api/auth/register`,
    postData
  );
}

export function login(email, password) {
  const postData = {
    email,
    password,
    //returnSecureToken: true,
  };
  return axios.post(
    `${process.env.REACT_APP_APIS_BASE_URL}/api/auth/login`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse.error?.message) {
    case "EMAIL_EXISTS":
      swal("Oops", "Email already exists", "error");
      break;
    case "EMAIL_NOT_FOUND":
      swal("Oops", "Email not found", "error", { button: "Try Again!" });
      break;
    case "INVALID_PASSWORD":
      swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(user, token) {
  //   tokenDetails.expireDate = new Date(
  //     new Date().getTime() + tokenDetails.expiresIn * 1000
  //   );
  // localStorage.setItem("userDetails", JSON.stringify(user));
  localStorage.setItem("access_token", token);
}

export function runLogoutTimer(dispatch, timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    dispatch(Logout(navigate));
  }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
  const tokenDetailsString = localStorage.getItem("access_token");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(Logout(navigate));
    return;
  }

  tokenDetails = (tokenDetailsString);
  let expireDate = new Date(tokenDetails.expireDate);
  let todaysDate = new Date();

  if (todaysDate > expireDate) {
    dispatch(Logout(navigate));
    return;
  }

  dispatch(loginConfirmedAction(tokenDetails));

  const timer = expireDate.getTime() - todaysDate.getTime();
  runLogoutTimer(dispatch, timer, navigate);
}

export function isLogin() {
  const tokenDetailsString = localStorage.getItem("access_token");

  if (tokenDetailsString) {
    return true;
  } else {
    return false;
  }
}
